import productCostService from '../services/productcost.service';
// import moment from 'moment'


const getDefaultState = () => {
  return {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    listItems: [],
    list_suppliers: [],
    total_lists_amount: {}
  }
}

export const productCostList = {
  namespaced: true,
  state: {
    stateData: getDefaultState()
  },
  actions: {
    resetState({commit}) {
      commit("resetState");
    },
    getListPartner({commit}, page=1, size=-1, type="1,2,3") {
			return productCostService.getListPartner(page, size, type).then(
				(response) => {
					return Promise.resolve(response);
				},
				(error) => {
					commit('getListPartnerFailure');
					return Promise.reject(error);
				}
			);
		},
    searchProductCost({commit}, conditions) {
      return productCostService.searchProductCost(conditions).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit('searchProductCostFailure');
          return Promise.reject(error);
        }
      );
    },
    deleteProductCost ({commit}, id="") {
      return productCostService.deleteProductCost(id).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          commit('deleteFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    resetState (state) {
      console.log("run resetState");
      Object.assign(state.stateData, getDefaultState());
    },
		getListPartnerFailure(state) {
			state.stateData.list_suppliers = [];
		},
    searchProductCostFailure() {
      console.log("run searchProductCostFailure");
    }
  },
  getters: {

  }
}